import strings from '../../resources/strings';

const { pdfContent } = strings.addFiles;
const consts = {
    formats: {
        pdf: 'application/pdf',
        image: 'image/*',
    },
    inputContent: {
        pdf: pdfContent,
    },
    path: {
        pdf: 'Attachments',
    },
};

export default consts;
